import { useEffect, useState } from "react";
import SEO from "../components/SEO";
import Reveal from "../components/Reveal";
import Breadcrumbs from "../components/Breadcrumbs";
import AssetPlaceholder from "../components/AssetPlaceholder";
import CTASection from "../components/CTASection";
import { getGallery } from "../lib/api";

export default function Gallery() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    getGallery().then(setItems).catch(() => setItems([])).finally(() => setLoading(false));
  }, []);
  return (
    <>
      <SEO
        title="Gallery / Our Work"
        description="Real Yavapai Waste Solutions trucks, roll-off dumpsters, deliveries, and job sites across Yavapai County."
        path="/gallery"
      />
      <section className="bg-white border-b border-slate-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-8 pb-12">
          <Breadcrumbs items={[{ label: "Home", to: "/" }, { label: "Gallery" }]} />
          <div className="mt-8 max-w-3xl">
            <h1 className="font-heading font-extrabold tracking-tight text-4xl sm:text-5xl text-slate-900 leading-[1.05]">Our Work</h1>
            <p className="mt-4 text-lg text-slate-600 leading-relaxed">
              Real trucks, real dumpsters, real job sites. This is what local service looks like.
            </p>
          </div>
        </div>
      </section>

      <section className="py-14 bg-slate-50" data-testid="gallery-grid">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {loading ? (
            <p className="text-slate-500">Loading gallery…</p>
          ) : (
            <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
              {items.map((item, i) => (
                <Reveal key={item.id || i} delay={i * 0.04}>
                  <figure className="rounded-xl overflow-hidden border border-slate-200 bg-white" data-testid={`gallery-item-${i}`}>
                    {item.type === "image" ? (
                      <img src={item.src} alt={item.alt || item.caption || "YWS at work"} className="w-full aspect-[4/3] object-cover hover:scale-[1.03] transition-transform duration-500" loading="lazy" />
                    ) : (
                      <AssetPlaceholder label={item.label} className="aspect-[4/3]" />
                    )}
                    {item.caption && (
                      <figcaption className="px-4 py-3 text-sm font-medium text-slate-700">{item.caption}</figcaption>
                    )}
                  </figure>
                </Reveal>
              ))}
            </div>
          )}
        </div>
      </section>

      <CTASection title="Want Your Project Handled Right?" />
    </>
  );
}
